import React, { memo } from 'react';
import { ScrollView, ScrollViewProps } from 'react-native';

// TODO: keyobard aware scrollview was not working with web so we have to revert to having scrollView for web and keyboard aware for mobile for now.

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MB_ModalUtilChildWrapperScrollView = memo(
  ({
    extraScrollHeight,
    ...props
  }: ScrollViewProps & {
    /**
     * Adds an extra offset to the keyboard. Useful if you want to stick elements
     * above the keyboard.
     */
    extraScrollHeight?: number;
  }) => {
    return <ScrollView {...props} />;
  }
);

export { MB_ModalUtilChildWrapperScrollView };
